import React from 'react';
import { useTranslation } from 'react-i18next';
import { KoobTooltip } from '@koob/ui';
import { ExperienceTypeEnum } from '@koob/enums';
import { FolderRowTypeEnum } from '@koob/utils';

const EXPERIENCE_ICONS = {
  [ExperienceTypeEnum.ACTIVITY]: 'fa-ticket',
  [ExperienceTypeEnum.TRANSFER]: 'fa-van-shuttle',
  [ExperienceTypeEnum.PROGRAM]: 'fa-calendar-image',
};

const TYPE_STYLES = {
  [FolderRowTypeEnum.TRIP]: 'bg-orange-500/10 text-orange-500',
  [FolderRowTypeEnum.HOTEL]: 'bg-blue-600/10 text-blue-700',
  [FolderRowTypeEnum.EXPERIENCE]: 'bg-violet-600/10 text-violet-700',
};

export interface FolderBookingTypeIconProps {
  type: string;
  /** Experience sub-type (Activity, Transfer, Program). */
  experienceType?: string | null;
}

/** KD-3842: suitcase (trip), bed (hotel) or the experience sub-type icon. */
export default function FolderBookingTypeIcon({
  type,
  experienceType,
}: FolderBookingTypeIconProps) {
  const { t } = useTranslation('folders');

  let icon = 'fa-suitcase-rolling';
  let tip = t('bookingsList.typeTrip');
  if (type === FolderRowTypeEnum.HOTEL) {
    icon = 'fa-bed';
    tip = t('bookingsList.typeHotel');
  } else if (type === FolderRowTypeEnum.EXPERIENCE) {
    icon = EXPERIENCE_ICONS[experienceType ?? ''] ?? 'fa-layer-group';
    tip = experienceType
      ? t('bookingsList.typeExperienceOf', { type: experienceType })
      : t('bookingsList.typeExperience');
  }

  return (
    <KoobTooltip tip={tip}>
      <span
        className={`inline-flex h-7 w-7 items-center justify-center rounded-md ${
          TYPE_STYLES[type] ?? TYPE_STYLES[FolderRowTypeEnum.EXPERIENCE]
        }`}
      >
        <i className={`fa-regular ${icon}`} aria-hidden="true" />
      </span>
    </KoobTooltip>
  );
}
